import consts from '@/consts';

export default class GameWeek {
  constructor({
    number = null,
    cutOffDate = null,
    startDate = null,
    endDate = null,
    status = null,
  } = {}) {
    this.number = number;
    this.cutOffDate = new Date(cutOffDate);
    this.startDate = new Date(startDate);
    this.endDate = new Date(endDate);
    this.status = status;
  }

  title() {
    return this.number < 605 ? `GW ${this.number - 501}` : `GW ${this.number - 604}`;
  }

  isOpen() {
    return this.status === consts.GAME_WEEK.STATUS.OPEN;
  }

  isWaiting() {
    return this.status === consts.GAME_WEEK.STATUS.WAITING;
  }

  isEnded() {
    return this.status === consts.GAME_WEEK.STATUS.ENDED;
  }

  dateRange() {
    const formatDate = (date, options) =>
      date.toLocaleDateString('en-US', options);

    const startMonth = formatDate(this.startDate, { month: 'short' });
    const endMonth = formatDate(this.endDate, { month: 'short' });

    const startFormatted = formatDate(this.startDate, { month: 'short', day: '2-digit' });
    const endFormatted =
      startMonth === endMonth
        ? formatDate(this.endDate, { day: '2-digit' })
        : formatDate(this.endDate, { month: 'short', day: '2-digit' });

    return `${startFormatted} - ${endFormatted}`;
  }


  static createFromObject(data) {
    return new GameWeek(data);
  }

  static createCollectionFromObject(data) {
    return data.map(
      (gameWeekData) => GameWeek.createFromObject(gameWeekData),
    );
  }
}
